module.exports = __webpack_public_path__ + "img/crystal_maiden_alt1.30a9f318.png";